var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.625 14.25H3.75C2.71447 14.25 1.875 13.4105 1.875 12.375V3.625C1.875 2.58947 2.71447 1.75 3.75 1.75H8.75C9.09518 1.75 9.375 2.02982 9.375 2.375C9.375 2.72018 9.09518 3 8.75 3H3.75C3.40482 3 3.125 3.27982 3.125 3.625V12.375C3.125 12.7202 3.40482 13 3.75 13H10.625C10.9702 13 11.25 12.7202 11.25 12.375V9.25C11.25 8.90482 11.5298 8.625 11.875 8.625C12.2202 8.625 12.5 8.90482 12.5 9.25V12.375C12.5 13.4105 11.6605 14.25 10.625 14.25Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51029 11.7216C4.63161 11.866 4.81163 11.9479 5.00018 11.9444C5.04224 11.9465 5.08436 11.9422 5.12518 11.9319L7.33143 11.4944C7.45268 11.469 7.56362 11.408 7.65018 11.3194L13.4002 5.57566C14.1313 4.84362 14.1313 3.6577 13.4002 2.92566C12.6553 2.22009 11.4888 2.22009 10.7439 2.92566L9.90018 3.76941C9.79701 3.87319 9.73777 4.00415 9.72244 4.13915C9.64282 4.34721 9.67788 4.59011 9.83143 4.76941L10.3377 5.27566C10.4546 5.39495 10.6144 5.46247 10.7814 5.46316C11.0353 5.46464 11.2649 5.31235 11.3623 5.07784C11.4597 4.84333 11.4055 4.57322 11.2252 4.39441L11.1288 4.29924L11.6189 3.79441C11.8627 3.55208 12.2564 3.55208 12.5002 3.79441C12.6185 3.91176 12.6851 4.07151 12.6851 4.23816C12.6851 4.40481 12.6185 4.56456 12.5002 4.68191L6.87518 10.3069L5.79393 10.5007L6.01893 9.41941L8.88143 6.55066C9.12376 6.30689 9.12376 5.91318 8.88143 5.66941C8.63766 5.42708 8.24395 5.42708 8.00018 5.66941L5.00018 8.66941C4.90925 8.75515 4.84612 8.86618 4.81893 8.98816L4.37518 11.2007C4.33932 11.3858 4.38897 11.5772 4.51029 11.7216Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.8dc23beac3b189cddc372ec745d6c755.svg";
export { ForwardRef as ReactComponent };